import { Title } from "@mantine/core";
import type { ReactNode } from "react";

interface HeadingProps {
  children?: ReactNode;
  id?: string;
  level?: number;
}

/**
 * Heading renders a heading node as a Mantine `Title` whose `order` matches the
 * Markdoc level and whose `id` anchors in-page links and the ToC. Non-h1 levels
 * carry a larger top margin so each section separates clearly from the prose
 * above it.
 */
export const Heading = ({ children, id, level = 1 }: HeadingProps) => {
  const order = Math.min(Math.max(level, 1), 6) as 1 | 2 | 3 | 4 | 5 | 6;
  const mt = order === 1 ? "lg" : "xl";

  return (
    <Title id={id} mt={mt} order={order}>
      {children}
    </Title>
  );
};
